import type { ReactNode } from 'react';
import { Card, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconDollarSignCircleFilled, IconHouseFilled, IconLockOpenFilled } from '@zillow/constellation-icons';

function GuarantorStepTip({ icon, heading, children }: { icon: ReactNode; heading: string; children: ReactNode }) {
  return (
    <Card elevated={false} tone="neutral">
      <Icon size="xl" css={{ marginBottom: 'default' }} render={icon} />
      <Heading level={2} textStyle="heading-sm" fontFamily="heading-alt" css={{ marginBottom: 'default' }}>
        {heading}
      </Heading>
      <Paragraph>{children}</Paragraph>
    </Card>
  );
}

export function GuarantorCurrentResidenceStepTip() {
  return (
    <GuarantorStepTip icon={<IconHouseFilled />} heading="Your current address">
      Provide your current address as part of your guarantor application.
    </GuarantorStepTip>
  );
}

export function GuarantorCurrentIncomeStepTip() {
  return (
    <GuarantorStepTip icon={<IconDollarSignCircleFilled />} heading="Your income">
      Share your income sources so the rental manager can assess your ability to cover rent as a guarantor.
    </GuarantorStepTip>
  );
}

export function GuarantorPastJobsStepTip() {
  return (
    <GuarantorStepTip icon={<IconDollarSignCircleFilled />} heading="Your employment history">
      Add your previous jobs to help the rental manager understand your employment history as part of your guarantor
      application.
    </GuarantorStepTip>
  );
}

export function GuarantorPaymentAndReportsStepTip() {
  return (
    <GuarantorStepTip icon={<IconLockOpenFilled />} heading="Your screening reports">
      Your credit and background reports help the rental manager evaluate your guarantor application.
    </GuarantorStepTip>
  );
}
